export class LocaleCurrency{
    id: string = '1';
    rate: any = "1";
    from_currency: string = localStorage.getItem('marketParams') ? (JSON.parse(localStorage.getItem('marketParams')))['currencySymbol'] : '₦';
    to_currency: string = localStorage.getItem('marketParams') ? (JSON.parse(localStorage.getItem('marketParams')))['currencySymbol'] : '₦';
    created_at: any = new Date();
    updated_at: any = new Date();
    ip:string = '127.0.0.1';
} 

export interface CurrentLocale{
  ip: string;
  network: string;
  version: string;
  city: string;
  region: string;
  region_code: string;
  country: string;
  country_name: string;
  country_code: string;
  country_code_iso3: string;
  country_capital: string;
  country_tld: string;
  continent_code: string;
  in_eu: boolean;
  postal?: any;
  latitude: number;
  longitude: number;
  timezone: string;
  utc_offset: string;
  country_calling_code: string;
  currency: string;
  currency_name: string;
  languages: string;
  country_area: number;
  country_population: number;
  asn: string;
  org: string;
}